export default __webpack_public_path__ + "media/a2542970d57af42101262f1c931df8e5cb50d2876e3be7f08a1021ec0df6f077.svg";